import getElementTop from '../utilities/get-element-top'
import getRequestParams from '../utilities/get-request-params'

const scrollToSection = {
	init() {
		const params = getRequestParams()
		if (params.section) {
			const fragment = document.querySelector('#' + params.section)
			if (fragment) {
				setTimeout(() => {
					let top = getElementTop(fragment)

					window.scrollTo({
						top: top,
						behavior: 'smooth',
					})
				}, 100)
			}
		}
	},
}

export default scrollToSection
